<template>
    <div class="marking-table">
        <div class="marrking-content">
            <div class="task-info">
                <div class="title">任务信息</div>
                <a-divider style="margin:0px" />
                <div class="content">
                    <div class="task-name">{{basicInfo.projectName}}</div>
                    <div class="task-id">
                        <span>任务id：</span>
                        <span>{{basicInfo.seriesNo}}</span>
                    </div>
                    <div style="font-size:rgba(80, 80, 80, 1);font-size:14px;margin:32px 0 8px 0">预计收入</div>
                    <div style="color:rgba(24, 144, 255, 1);font-size:18px;font-weight:bold">
                        <span>￥</span>
                        <span>{{statisticInfo.money}}</span>
                        <span>元</span>
                    </div>
                    <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin:32px 0 0 0">我的任务进度</div>
                    <div style="display:flex;margin-top:8px;">
                        <span style="display:inline-block;width:25px;font-size:12px;color:rgba(24, 144, 255, 1)">{{statisticInfo.finishWordCount}}</span>
                        <a-progress style="width:200px;margin:0 8px;flex:1" :percent="statisticInfo.finishWordCount/statisticInfo.totalWordCount*100" status="active" :showInfo="false"/>
                        <span style="display:inline-block;width:25px;font-size:12px;color:rgba(170, 170, 170, 1)">{{statisticInfo.totalWordCount}}</span>
                    </div>
                    <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin:32px 0 8px 0">离截止日期还剩</div>
                    <div style="margin-bottom:24px;height:28px;">
                        <span style="color:rgba(255, 70, 70, 1);font-size:20px;font-weight:bold;float:left">{{countDown.day}}</span>
                        <span style="color:rgba(170, 170, 170, 1);font-size:12px;float:left;margin:7px 2px 0">天</span>
                        <span style="color:rgba(255, 70, 70, 1);font-size:20px;font-weight:bold;float:left">{{countDown.hour}}</span>
                        <span style="color:rgba(170, 170, 170, 1);font-size:12px;float:left;margin:7px 2px 0">时</span>
                        <span style="color:rgba(255, 70, 70, 1);font-size:20px;font-weight:bold;float:left">{{countDown.min}}</span>
                        <span style="color:rgba(170, 170, 170, 1);font-size:12px;float:left;margin:7px 2px 0">分</span>
                        <span style="color:rgba(255, 70, 70, 1);font-size:20px;font-weight:bold;float:left">{{countDown.sec}}</span>
                        <span style="color:rgba(170, 170, 170, 1);font-size:12px;float:left;margin:7px 2px 0">秒</span>
                    </div>
                    <a-divider style="margin:0px" />
                    <div style="clear:both;margin-bottom:24px;"></div>
                    <div>
                        <div>
                            <span style="float:left;color:rgba(80, 80, 80, 1);font-size:14px">进度排行</span>
                            <span @click="refreshData" style="float:right;color:rgba(24, 144, 255, 1);font-size:12px;cursor:pointer">
                                <a-icon type="redo" />
                                刷新
                            </span>
                        </div>
                        <div style="clear:both"></div>
                        <div v-for="(item, index) in statisticInfo.rank" :key="index" style="display:flex;margin-top:16px;">
                            <span :title='item.name' style="display:inline-block;width:50px;color:rgba(170, 170, 170, 1);font-size:12px;overflow:hidden;">{{item.name}}：</span>
                            <a-progress style="width:190px;margin:0 8px;flex:1" :percent="item.finishWordCount/item.totalWordCount*100" status="active" :showInfo="false"/>
                            <div style="display:inline-block;width:60px;font-size:12px;">
                                <span style="color:rgba(34, 215, 187, 1)">{{item.finishWordCount}}</span>
                                <span style="color:rgba(170, 170, 170, 1)">/{{item.totalWordCount}}</span>
                            </div>
                        </div>
                    </div>
                    <a-divider style="margin:24px 0" />
                </div>
            </div>
            <div class="marking-area">
                <div style="padding:12px 24px;height:48px">
                    <span style="font-size:16px;color:rgba(51, 51, 51, 1)">标注内容区域</span>
                    <a-input-search v-model="searchContent" placeholder="请输入搜索内容" style="width: 200px;margin-left:100px;" @search="onSearch" />
                    <div style="display:inline-block;float:right;color:rgba(24, 144, 255, 1)">
                        <div v-if="!ifShowAutoTeam" @click="autoTeam" style="display:inline-block;margin-right:48px;cursor:pointer">
                            <a-icon type="ordered-list" style="margin-right:5px" />
                            <span>自动分组</span>
                        </div>
                        <div v-if="ifShowAutoTeam" @click="offAutoTeam" style="display:inline-block;margin-right:48px;cursor:pointer">
                            <a-icon type="undo" style="margin-right:5px" />
                            <span>取消自动分组</span>
                        </div>
                        <div @click="changeBatch" style="display:inline-block;margin-right:6px;cursor:pointer">
                            <a-icon type="sync" style="margin-right:5px" />
                            <span>换一批</span>
                        </div>
                    </div>
                </div>
                <div v-if="!ifShowAutoTeam" class="panel-list" style="background:rgba(241, 229, 201, 1);padding:6px 35px 24px 24px">
                    <span @click="selectWord(item,index)" v-for="(item, index) in taskWordList" :key="index" :class="{'active':wordActiveList[index]==2,'marked':wordActiveList[index]==3}">
                        {{item.content}}
                    </span>
                </div>
                <div v-if="ifShowAutoTeam" class="intention-team-list">
                    <div v-for="(item, index) in teamIntentionList" :key="index" style="background:rgba(241, 229, 201, 1);margin-bottom:16px;padding:24px;">
                        <div>{{item.name}}</div>
                        <div>
                            <span @click="selectIntentionItem(index,index1)" v-for="(item1, index1) in item.list" :key="index1" :class="{'active':intentionActiveList[index][index1]}">{{item1}}</span>
                        </div>
                    </div>
                    <div style="text-align:right;color:rgba(24, 144, 255, 1);margin:12px 24px">
                        <a-icon type="upload" style="margin-right:5px" />
                        <span style="cursor:pointer;font-size:16px">确认提交</span>
                    </div>
                </div>
                
            </div>
            <div class="intemtion-area">
                <div class="title">
                    <span>意图选择区域</span>
                    <span class="title-explain" @click="showExplation">
                        <a-icon type="exclamation-circle"  style="margin-right:5px;font-size:16px;"/>
                        <span>解释说明</span>
                    </span>
                </div>
                <a-divider style="margin:0px" />
                <div class="intention-area">
                    <div>
                        <span @dblclick="showIntentionModel(0,'放弃')" @click="selectCurrentIntention(0)" :class="{'active':currentIntention==-1}" class="intention-list">放弃</span>
                        <span @dblclick="showIntentionModel(item.id,item.name)" @click="selectCurrentIntention(item.id)" :title="item.name" v-for="(item, index) in intentionList" :key="index" :class="{'active':currentIntention==index}">{{item.name.length>10?item.name.substring(0,10)+'...':item.name}}</span>
                    </div>
                </div>
            </div>
        </div>
        <a-modal v-model="visibleIntention" :title="currentIntentionName" :footer='null' :maskClosable='false' width='600px'>
            <div style="border:1px solid rgba(238, 238, 238, 1);padding:24px;border-radius:4px;max-height:600px;overflow-y:auto">
                <a-checkbox-group @change="onChange">
                    <a-checkbox v-for="(item, index) in intentionSampleList" :key="index" :value="item.id" style="display:block;margin-bottom:16px">
                        {{item.content}}
                    </a-checkbox>
                </a-checkbox-group>
            </div>
            <div style="text-align:center;margin-top:24px">
                <a-button type="primary" style="width:80px" @click="backTaggingWord">
                    还原
                </a-button>
            </div>
        </a-modal>
        <a-modal v-model="explationModal" title="解释说明" :footer='null' :maskClosable='false' width='350px'>
            <div class="explation-modal">
                <div>1.您可将鼠标悬浮至每个意图按钮上，查看标注样本，全面了解该意图的意思。</div>
                <div>2.当您无法判断话句意图时，单击“放弃”按钮，不进行标注。</div>
                <div>3.双击意图，查看该意图下您已标注过的话句，您可检查并还原不正确的语句，重新标注。</div>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    name: 'TaskManage',
    props: {
        msg: String
    },
    data() {
        return {
            wordActiveList: [],
            ifShowAutoTeam: false,
            teamIntentionList: [],
            intentionActiveList: [],
            intentionSelectList: [],
            currentIntention: null,
            visibleIntention: false,
            basicInfo: '',
            statisticInfo: '',
            countDown: '',
            intentionList: [],
            intentionSampleList: [],
            taskWordList: [],
            taskId: '',
            selectedWordList: [],
            currentIntentionName: '',
            needBackWordId: '',
            times: 0,
            explationModal: false,
            searchContent: ''
        }
    },
    /*
        1.初始状态
        2.高亮状态
        3.被标记状态
    */
    methods: {
        selectWord(item,index) {
            if(this.wordActiveList[index] == 1){
                this.wordActiveList[index] = 2
                this.selectedWordList.push(item.id)
            }else if(this.wordActiveList[index] == 2){
                this.wordActiveList[index] = 1
                for(let i = 0; i < this.selectedWordList.length; i++){
                    if(this.selectedWordList[i] == item.id){
                        this.selectedWordList.splice(i,1);
                    }
                }
            }
            this.$forceUpdate()
        },
        selectCurrentIntention(id) {
            if(this.selectedWordList.length > 0){
                this.axios.post('/api/user/task/word', {
                    wordIdList: this.selectedWordList,
                    intentionId: id,
                    taskId: this.taskId
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.selectedWordList = []
                        for(let i = 0; i < this.wordActiveList.length; i++){
                            if(this.wordActiveList[i] == 2){
                                this.wordActiveList[i] = 3
                            }
                        }
                        this.$forceUpdate()
                    }else{
                        this.$parent.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            }
        },
        autoTeam() {
            this.ifShowAutoTeam = true
        },
        changeBatch() {
            this.wordActiveList = []
            this.selectedWordList = []
            this.queryTaskWordData(this.taskId)
        },
        offAutoTeam() {
            this.ifShowAutoTeam = false
        },
        selectIntentionItem(index,index1) {
            this.intentionActiveList[index][index1] = !this.intentionActiveList[index][index1]
            this.$forceUpdate()
        },
        showIntentionModel(id, name) {
            this.visibleIntention = true
            this.currentIntentionName = name
            this.axios({
                url: '/api/user/task/intention/word/list', 
                method: 'get',
                params: {
                    taskId: this.taskId,
                    intentionId: id
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.intentionSampleList = response.data.data
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        onChange(checkedValues) {
            this.needBackWordId = checkedValues
        },
        queryBasicInfo(id) {
            this.axios({
                url: '/api/user/task/base', 
                method: 'get',
                params: {
                    id: id,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.basicInfo = response.data.data
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryStatisticInfo(id) {
            this.axios({
                url: '/api/user/statistic/task', 
                method: 'get',
                params: {
                    id: id,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.times ++
                    this.statisticInfo = response.data.data
                    if(this.times == 1){
                        this.queryTimeOut(response.data.data.leftSecond)
                    }
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryTimeOut(data) {
            let time = data
            setInterval(()=>{
                time = time - 1
                this.countDown = this.secondToDate(time)
            },1000)
        },
        secondToDate(msd) {
            let time = {
                day : '',
                hour: '',
                min: '',
                sec: ''
            }
            time.sec = Math.floor(msd / 1) % 60;
            msd = Math.floor(msd / 60);
            time.min = msd % 60;
            msd = Math.floor(msd / 60);
            time.hour = msd % 24;
            msd = Math.floor(msd / 24);
            time.day = msd;
            return time;
        },
        queryIntentionData(id) {
            this.axios({
                url: '/api/user/task/intention/list', 
                method: 'get',
                params: {
                    taskId: id,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.intentionList = response.data.data
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryTaskWordData(id) {
            this.axios({
                url: '/api/user/task/word/list', 
                method: 'get',
                params: {
                    taskId: id,
                    keyword: this.searchContent
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.taskWordList = response.data.data
                    this.wordActiveList = []
                    this.taskWordList.map(()=>{
                        this.wordActiveList.push(1)
                    })
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        querySample() {
            this.axios.post('/api/user/task/intention/word/list', {
                intentionId: '',
                taskId: ''
            })
            .then(response=> {
                if(response.data.code == 0){
                    console.log(response.data)
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        backTaggingWord() {
            this.visibleIntention = false
            this.axios.post('/api/user/task/word/reback', {
                wordIdList: this.needBackWordId,
                taskId: this.taskId
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$parent.success('回滚成功');
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        refreshData() {
            this.queryStatisticInfo(this.taskId)
        },
        showExplation() {
            this.explationModal = true
        },
        onSearch() {
            this.searchContent = this.trim(this.searchContent)
            if(this.searchContent == ""){
                this.$parent.error('请输入搜索内容');
            }else{
                this.queryTaskWordData(this.taskId)
            }
        },
        trim(str){
            return str.replace(/(^\s*)|(\s*$)/g, '');
        }
    },
    mounted: function() {
        this.taskId = this.$route.query.taskId
        this.queryBasicInfo(this.taskId)
        this.queryStatisticInfo(this.taskId)
        this.queryIntentionData(this.taskId)
        this.queryTaskWordData(this.taskId)
    }
}
</script>
<style scoped lang="less">
    .marking-table{
        padding: 24px;
        width: 100%;
        flex: 1;
        overflow: hidden;
        .marrking-content{
            display: flex;
            height: 100%;
            .task-info{
                width: 320px;
                background: #fff;
                border-radius: 4px;
                box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.04);
                height: 100%;
                overflow-y: auto;
                .title{
                    color: rgba(51, 51, 51, 1);
                    font-size: 16px;
                    padding: 12px 24px;
                }
                .content{
                    padding: 24px;
                    .task-name{
                        color: rgba(51, 51, 51, 1);
                        font-size: 18px;
                        margin-bottom: 8px;
                        font-weight: bold;
                    }
                    .task-id{
                        color: rgba(204, 204, 204, 1);
                        font-size: 14px;
                    }
                }
            }
            .marking-area{
                flex: 1;
                background: #fff;
                margin: 0 16px;
                border-radius: 4px;
                box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.04);
                display: flex;
                flex-direction: column;
                .panel-list{
                    flex: 1;
                    overflow-y: auto;
                    span{
                        display:inline-block;
                        padding: 8px 12px;
                        font-size:14px;
                        color: rgba(51, 51, 51, 1);
                        margin: 18px 16px 0 0;
                        background: rgba(255, 255, 255, 0.5);
                        border-radius: 4px;
                        cursor: pointer;
                    }
                    span.active{
                        color: #fff;
                        background:rgba(206, 183, 115, 1);
                    }
                    span.marked{
                        color:rgb(241, 229, 201);
                        background: rgb(241, 229, 201);
                        cursor: default;
                    }
                }
                .intention-team-list{
                    height: 100%;
                    overflow-y: auto;
                    div{
                        div{
                            span{
                                display:inline-block;
                                padding: 8px 12px;
                                font-size:14px;
                                color: rgba(51, 51, 51, 1);
                                margin: 18px 16px 0 0;
                                background: rgba(255, 255, 255, 0.5);
                                border-radius: 4px;
                                cursor: pointer;
                            }
                            span.active{
                                color: #fff;
                                background:rgba(206, 183, 115, 1);
                            }
                        }
                    }
                }
            }
            .intemtion-area{
                width: 464px;
                background: #fff;
                border-radius: 4px;
                box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.04);
                height: 100%;
                overflow-y: auto;
                .title{
                    color: rgba(51, 51, 51, 1);
                    font-size: 16px;
                    padding: 12px 24px;
                    .title-explain{
                        color: rgba(204, 204, 204, 1);
                        font-size: 14px;
                        float: right;
                        cursor: pointer;
                    }
                    .title-explain:hover{
                        color: rgb(24, 144, 255);
                    }
                }
                .intention-area{
                    padding: 8px 24px 24px 8px;
                    .intention-list{
                        height: 32px;
                        line-height: 32px;
                        width: 416px;
                        background: rgba(0, 0, 0, 0.05);
                        color: rgba(255, 0, 33, 1);
                        border-radius: 4px;
                        border: 1px solid rgba(217, 217, 217, 1);
                        text-align: center;
                        cursor: pointer;
                        margin-left: 16px;
                    }
                    div{
                        span{
                            display:inline-block;
                            margin: 16px 0 0 16px;
                            text-align: center;
                            cursor: pointer;
                            height: 32px;
                            line-height: 32px;
                            border: 1px solid rgba(229, 229, 229, 1);
                            border-radius: 4px;
                            color: rgba(80, 80, 80, 1);
                            width: 200px;
                            overflow: hidden;
                            float: left;
                            padding: 0 8px;
                        }
                        span:hover{
                            border-color: rgba(24, 144, 255, 1);
                            color: rgba(24, 144, 255, 1);
                        }
                        span.active{
                            color: #fff;
                            background: rgba(24, 144, 255, 1);
                        }
                    }
                }
            }
        }
    }
    .ant-checkbox-wrapper{
        margin-left: 0px !important;
    }
    .explation-modal{
        color: rgba(51, 51, 51, 1);
        font-size: 14px;
        div:nth-child(2){
            margin: 10px 0;
        }
    }
</style>
